module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAQCAYAAADwMZRfAAAAAXNSR0IArs4c6QAAARdJREFUOBFj/P///14GBgY7ICYXrGIEGvKfXN1QfS9YoIy1QHo2iYYxAtUXArEezJDfQM5bID4IxGxATAh8ByowA2KQPgYGkHegIArGIJKOgKp7DnLJYSC2BRkIBf+ANMhVuIAomsQhMB9oIiiAPaAmd6MpQuEC1SyGqtMH0qBwYQCHCSMjSiQVAyUTUXQiOCBNQjAuSB+IDQtYmDiIvgbE25AFkNggQ0KAWAFJDKsh94AKIP5EVglhgwyxAGIFCBdCYnOJL1AKhIkGTESrxKOQpoZcBVr8A83yr0D+RTQxMBfdJc+AolHAqNMB0rpAvAesioFhLZDWBIobAOlwIH4OFUelgGmDA4h5UEXB2UIBixgPUC08UgCp+ZbzGlU+SwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/center/menu/bill.png
// module id = q6EE
// module chunks = 26